import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/ndarray/base/assert';
import __var_2__ from '@stdlib/ndarray/base/bind2vind';
import __var_3__ from '@stdlib/ndarray/base/buffer';
import __var_4__ from '@stdlib/ndarray/base/buffer-ctors';
import __var_5__ from '@stdlib/ndarray/base/buffer-dtype';
import __var_6__ from '@stdlib/ndarray/base/bytes-per-element';
import __var_7__ from '@stdlib/ndarray/base/clamp-index';
import __var_8__ from '@stdlib/ndarray/base/ctor';
import __var_9__ from '@stdlib/ndarray/base/dtype-char';
import __var_10__ from '@stdlib/ndarray/base/dtypes2signatures';
import __var_11__ from '@stdlib/ndarray/base/ind';
import __var_12__ from '@stdlib/ndarray/base/ind2sub';
import __var_13__ from '@stdlib/ndarray/base/iteration-order';
import __var_14__ from '@stdlib/ndarray/base/max-view-buffer-index';
import __var_15__ from '@stdlib/ndarray/base/memoized-ctor';
import __var_16__ from '@stdlib/ndarray/base/min-view-buffer-index';
import __var_17__ from '@stdlib/ndarray/base/minmax-view-buffer-index';
import __var_18__ from '@stdlib/ndarray/base/nonsingleton-dimensions';
import __var_19__ from '@stdlib/ndarray/base/numel';
import __var_20__ from '@stdlib/ndarray/base/shape2strides';
import __var_21__ from '@stdlib/ndarray/base/singleton-dimensions';
import __var_22__ from '@stdlib/ndarray/base/strides2offset';
import __var_23__ from '@stdlib/ndarray/base/strides2order';
import __var_24__ from '@stdlib/ndarray/base/sub2ind';
import __var_25__ from '@stdlib/ndarray/base/to-array';
import __var_26__ from '@stdlib/ndarray/base/vind2bind';
import __var_27__ from '@stdlib/ndarray/base/wrap-index';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name assert
* @memberof ns
* @readonly
* @type {Namespace}
* @see {@link module:@stdlib/ndarray/base/assert}
*/
setReadOnly( ns, 'assert', __var_1__);

/**
* @name bind2vind
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/bind2vind}
*/
setReadOnly( ns, 'bind2vind', __var_2__);

/**
* @name buffer
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/buffer}
*/
setReadOnly( ns, 'buffer', __var_3__);

/**
* @name bufferCtors
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/buffer-ctors}
*/
setReadOnly( ns, 'bufferCtors', __var_4__);

/**
* @name bufferDataType
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/buffer-dtype}
*/
setReadOnly( ns, 'bufferDataType', __var_5__);

/**
* @name bytesPerElement
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/bytes-per-element}
*/
setReadOnly( ns, 'bytesPerElement', __var_6__);

/**
* @name clampIndex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/clamp-index}
*/
setReadOnly( ns, 'clampIndex', __var_7__);

/**
* @name ndarray
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/ctor}
*/
setReadOnly( ns, 'ndarray', __var_8__);

/**
* @name dtypeChar
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/dtype-char}
*/
setReadOnly( ns, 'dtypeChar', __var_9__);

/**
* @name dtypes2signatures
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/dtypes2signatures}
*/
setReadOnly( ns, 'dtypes2signatures', __var_10__);

/**
* @name ind
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/ind}
*/
setReadOnly( ns, 'ind', __var_11__);

/**
* @name ind2sub
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/ind2sub}
*/
setReadOnly( ns, 'ind2sub', __var_12__);

/**
* @name iterationOrder
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/iteration-order}
*/
setReadOnly( ns, 'iterationOrder', __var_13__);

/**
* @name maxViewBufferIndex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/max-view-buffer-index}
*/
setReadOnly( ns, 'maxViewBufferIndex', __var_14__);

/**
* @name ndarrayMemoized
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/memoized-ctor}
*/
setReadOnly( ns, 'ndarrayMemoized', __var_15__);

/**
* @name minViewBufferIndex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/min-view-buffer-index}
*/
setReadOnly( ns, 'minViewBufferIndex', __var_16__);

/**
* @name minmaxViewBufferIndex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/minmax-view-buffer-index}
*/
setReadOnly( ns, 'minmaxViewBufferIndex', __var_17__);

/**
* @name nonsingletonDimensions
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/nonsingleton-dimensions}
*/
setReadOnly( ns, 'nonsingletonDimensions', __var_18__);

/**
* @name numel
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/numel}
*/
setReadOnly( ns, 'numel', __var_19__);

/**
* @name shape2strides
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/shape2strides}
*/
setReadOnly( ns, 'shape2strides', __var_20__);

/**
* @name singletonDimensions
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/singleton-dimensions}
*/
setReadOnly( ns, 'singletonDimensions', __var_21__);

/**
* @name strides2offset
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/strides2offset}
*/
setReadOnly( ns, 'strides2offset', __var_22__);

/**
* @name strides2order
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/strides2order}
*/
setReadOnly( ns, 'strides2order', __var_23__);

/**
* @name sub2ind
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/sub2ind}
*/
setReadOnly( ns, 'sub2ind', __var_24__);

/**
* @name ndarray2array
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/to-array}
*/
setReadOnly( ns, 'ndarray2array', __var_25__);

/**
* @name vind2bind
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/vind2bind}
*/
setReadOnly( ns, 'vind2bind', __var_26__);

/**
* @name wrapIndex
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/ndarray/base/wrap-index}
*/
setReadOnly( ns, 'wrapIndex', __var_27__);


// EXPORTS //
export default ns;

export { __var_1__ as assert, __var_2__ as bind2vind, __var_3__ as buffer, __var_4__ as bufferCtors, __var_5__ as bufferDataType, __var_6__ as bytesPerElement, __var_7__ as clampIndex, __var_8__ as ndarray, __var_9__ as dtypeChar, __var_10__ as dtypes2signatures, __var_11__ as ind, __var_12__ as ind2sub, __var_13__ as iterationOrder, __var_14__ as maxViewBufferIndex, __var_15__ as ndarrayMemoized, __var_16__ as minViewBufferIndex, __var_17__ as minmaxViewBufferIndex, __var_18__ as nonsingletonDimensions, __var_19__ as numel, __var_20__ as shape2strides, __var_21__ as singletonDimensions, __var_22__ as strides2offset, __var_23__ as strides2order, __var_24__ as sub2ind, __var_25__ as ndarray2array, __var_26__ as vind2bind, __var_27__ as wrapIndex};